// extracted by mini-css-extract-plugin
module.exports = {"booking-wizard":"k_bw","bookingWizard":"k_bw","block":"k_bx","button":"k_by"};